import constantLoader from "./constant.mjs";
import languageLoader from "./language.mjs";

export const loaderParser = {
  constants: {
    parser: constantLoader,
    dataType: "constant",
    url: "constant.json",
  },
  "language/en-us": {
    parser: languageLoader,
    dataType: "language",
    url: "language/en-us.json",
  },
};
